import React from 'react'
import { Link } from 'react-router-dom'
import { getIcon } from '../project'

function ProjectTabs({ array, num, setNum, bigLabels }) {
    function getTabIcon(biglabel, values) {
        var label = String(biglabel || '').replace(/\s/g, '')

        if (label === '전체') return getIcon(0)
        if (label.includes('프로젝트등록')) return getIcon(1)
        if (label.includes('견적')) return getIcon(3)
        if (label.includes('계약')) return getIcon(8)
        if (label.includes('진행') || label.includes('개발') || label.includes('납부')) return getIcon(12)
        if (label.includes('완료')) return getIcon(31)

        return getIcon(values && values[0] ? values[0].value : 0)
    }

    return (
        <div className="ProjectTabs w1480">
            {bigLabels && num ? (
                <ul className="flex j">
                    {Object.entries(bigLabels).map(([biglabel, values], index) => {
                        const isActive = num[0] === biglabel

                        return (
                            <li
                                className={`${isActive ? 'active' : ''} `}
                                onClick={() => setNum([biglabel, values[0].value])}
                                key={values[0].value}
                            >
                                <Link className="top_tap" to={`${values[0].paths}`}>
                                    <span className="tag_triangle"></span>
                                    {/* {getIcon(values[0].value)} */}
                                    {getTabIcon(biglabel, values)}
                                    <span className="mr10"></span>
                                    {biglabel}(
                                    {biglabel === '전체'
                                        ? array.length
                                        : array &&
                                          array.filter((proj) => {
                                              return bigLabels[biglabel].some(
                                                  (labelObj) => labelObj.label === proj.adminstatus,
                                              )
                                          }).length}
                                    )
                                </Link>
                            </li>
                        )
                    })}
                </ul>
            ) : (
                ''
            )}
        </div>
    )
}

export default ProjectTabs
